export default __webpack_public_path__ + "static/media/Ashoka_Particle_Flame_1.b66046c0.png";